if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        const variantId = formData.get('id');
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        this.attachFreeGift(formData)
          .then(() => fetch(`${routes.cart_add_url}`, config))
          .then((response) => response.json())
          .then((response) => {
            // Multi-item add returns { items: [...] }; expose the main item's fields for cart drawer/notification
            if (response.items) Object.assign(response, response.items[0]);
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: variantId,
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: variantId,
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      // Free gift (set via buy-buttons block): Shopify BXGY automatic discounts only discount the gift,
      // they never add it. Convert the request to items[] so main product + gift are added in one call.
      async attachFreeGift(formData) {
        const giftVariantId = this.dataset.freeGiftVariantId;
        if (!giftVariantId) return;

        const minQty = parseInt(this.dataset.freeGiftMinQty) || 1;
        const qty = parseInt(formData.get('quantity')) || 1;
        if (qty < minQty || String(formData.get('id')) === giftVariantId) return;

        try {
          const cart = await fetch(`${routes.cart_url}.js`).then((res) => res.json());
          const alreadyInCart = cart.items.some(
            (item) => String(item.variant_id) === giftVariantId && item.properties && item.properties._free_gift
          );
          if (alreadyInCart) return;
        } catch (e) {
          // If the cart lookup fails, still add the gift
        }

        const passthrough = ['sections', 'sections_url', 'form_type', 'utf8', 'product-id', 'section-id'];
        for (const [key, value] of [...formData.entries()]) {
          if (passthrough.includes(key)) continue;
          formData.delete(key);
          const field = key.match(/^([^\[]+)(.*)$/);
          formData.append(`items[0][${field[1]}]${field[2]}`, value);
        }
        if (!formData.has('items[0][quantity]')) formData.append('items[0][quantity]', qty);

        formData.append('items[1][id]', giftVariantId);
        formData.append('items[1][quantity]', 1);
        formData.append('items[1][properties][_free_gift]', 'true');
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
